import { getItem } from "@/utils/localStorageControl.js";
// import { logOut } from "../services/authservices";

import { handleRouting } from "@/utils/constants";

export default function auth({ to, next, store }) {
  const isLoggedIn = store.getters.isLoggedIn;
  const adminCategory = [0, 3, 4];
  const userApps = store.getters.userApps;
  const selectedApp =
    getItem("selectedApp") || process.env.VUE_APP_FLUX_APP_CODE;
  const userCategory = store.getters.loggedUser?.userCategory;

  // Check if the route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isLoggedIn) {
      console.log({
        userApps,
        selectedApp,
        userCategory,
        validate:
          adminCategory.includes(parseInt(userCategory)) &&
          userApps?.includes(selectedApp),
      });
      // return;
      if (
        adminCategory.includes(parseInt(userCategory)) &&
        userApps?.includes(selectedApp)
      ) {
        console.log("allowed");
        next(); // ✅ allow navigation to proceed
      } else {
        console.log("not allowed");
        // logOut(); // ✅ force logout for unauthorized users
      }
    } else {
      console.log("not logged in then route");
      handleRouting(); // redirect to SSO login
    }
  } else {
    console.log("not logged in then next");
    next();
  }
}
